export default __webpack_public_path__ + "static/media/yellowFlowerWithBlueAndOrange.1c81465e.jpg";